import { StrictMode, useEffect } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter, useLocation } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import "./styles/pep.css";
import "./styles/pep-edition.css";
import "./styles/pep-product-vertical.css";
import "./styles/pep-product-detail-hd.css";
import "./styles/pep-why.css";
import "./styles/pep-contact.css";
import "./styles/pep-knowledge.css";
import { AnalyticsConsentBanner } from "./analytics/AnalyticsConsent";
import { trackPageView } from "./analytics/pep-analytics";
import { AffiliateRefCapture } from "./components/affiliate/AffiliateRefCapture";
import { PepErrorBoundary } from "./components/feedback/PepErrorBoundary";
import { PepProviders } from "./providers/PepProviders";
import { AppRouter } from "./router/routes";

function PageViewTracker() {
  const location = useLocation();

  useEffect(() => {
    void trackPageView(`${location.pathname}${location.search}`);
  }, [location.pathname, location.search]);

  return null;
}

function AppShell() {
  return (
    <>
      <AffiliateRefCapture />
      <PageViewTracker />
      <AppRouter />
      <AnalyticsConsentBanner />
    </>
  );
}

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <PepErrorBoundary>
      <PepProviders>
        <BrowserRouter>
          <AppShell />
        </BrowserRouter>
      </PepProviders>
    </PepErrorBoundary>
  </StrictMode>,
);
